import React from "react"
import Navbar from "./Navbar/index"

export default function Layout(props) {
  return (
    <div>
      <Navbar />
      <div style={{ margin: "0 auto", width: "95vw", overflowX: "hidden" }}>
        {props.children}
      </div>
    </div>
  )
}

// #f8f5f1
// #f9f3f3
// #fffbf0
